import React, {PureComponent} from 'react';
import {withStyles} from 'material-ui/styles';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';
import HousecallIcon from "housecall-ui/dist/IconsAndImages/Icons/Housecall"
import { isBlank } from 'utils/isBlank';

const styles = theme => ({
    chipBackground: {
        backgroundColor: '#00e676',
    },
    chipIcon: {
        backgroundColor: '#00c853',
    },
    chipLabel: {
        color: '#ffffff'
    },
});

@withStyles(styles)
export default class ConsumerAppChip extends PureComponent {

    render() {
        const {classes} = this.props;

        let label = this.props.label;
        if (isBlank(label)) {
            label = "Housecall app user"
        }

        return <Chip
            avatar={
                <Avatar className={classes.chipIcon}>
                    <HousecallIcon style={{width: 20}} nativeColor="#ffffff"/>
                </Avatar>
            }
            label={label}
            className={`${classes.chipBackground} ${this.props.className}`}
            classes={{label: classes.chipLabel}}
        />
    }
}
